<span class="cm-icon cm-icon-sending small icon" aria-hidden="true" [style.color]="color"></span>
<ng-content></ng-content>
